import { render } from "./ColorChooserItem.vue?vue&type=template&id=001bc1f4&scoped=true"
import script from "./ColorChooserItem.vue?vue&type=script&lang=js"
export * from "./ColorChooserItem.vue?vue&type=script&lang=js"

import "./ColorChooserItem.vue?vue&type=style&index=0&id=001bc1f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-001bc1f4"

export default script